module.exports = __webpack_public_path__ + "media/images/top/sweets-54a755101754b2630c0fc90696d3d0a9.svg";